const e = "enter_ZKAMl", t = "enterActive_x7DuF", c = "exit_kQkG2", i = "exitActive_mYc6H", n = {
  enter: e,
  enterActive: t,
  exit: c,
  exitActive: i
};
export {
  n as default,
  e as enter,
  t as enterActive,
  c as exit,
  i as exitActive
};
//# sourceMappingURL=opacityAnimation.module.scss.js.map
